import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { UserType, User, DocTemplate } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';
import { DoctemplateEditComponent } from '../doctemplate-edit/doctemplate-edit.component';

@Component({
	selector: 'app-doctemplate-list',
	templateUrl: './doctemplate-list.component.html',
	styleUrls: ['./doctemplate-list.component.scss']
})
export class DoctemplateListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: DocTemplate[];

	advancedSearch: Search = new Search('doctemplate', `concat(name,'',slug)`, 'doctemplate');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	tenderid: number;

	loggedUser: User;
	subcription: Subscription;

	constructor(
		private docTemplateService: CrudService<DocTemplate>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.tenderid) {
			this.advancedSearch.addSimpleFilter('tenderid', this.tenderid);
		}

		const datarequest = this.docTemplateService.searchEntities(DocTemplate, 'doctemplate', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.docTemplateService.countEntities(DocTemplate, 'doctemplate', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}



	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: DocTemplate, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-doctemplate-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.docTemplateService.deleteEntity(DocTemplate, 'doctemplate', row).subscribe(() => {
					this.translateService.get(['labels.doctemplate-deleted', 'labels.doctemplate']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.doctemplate-deleted'], messages['labels.doctemplate']);
						this.load();
					});
				});
			}
		});
	}


	edit(doctemplateid?: number) {
		const modal = this.modalService.open(DoctemplateEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.tenderid = this.tenderid;

		if (doctemplateid) {
			modal.componentInstance.load(doctemplateid);
		}
		modal.result.then((newItem: DocTemplate) => {
			this.load();
		}).catch(() => { });
	}

}
